// extracted by mini-css-extract-plugin
export default {"workerList":"Debug_workerList__EkGXv","workerListItem":"Debug_workerListItem__EFBST","workerState":"Debug_workerState__uRbtV","idle":"Debug_idle__UQs6W","busy":"Debug_busy__sEvUM"};